(() => {
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  const settings = {
    count: 90,          // number of dots
    minSize: 2,
    maxSize: 4,
    minSpeed: 0.3,
    maxSpeed: 1.4,
    drift: 0.35,        // horizontal movement
    opacityMin: 0.35,
    opacityMax: 0.9
  };

  const canvas = document.createElement("canvas");
  canvas.id = "pp-snowfall";
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  let w = 0, h = 0, raf = null;
  let particles = [];

  const resize = () => {
    w = canvas.width = window.innerWidth;
    h = canvas.height = window.innerHeight;
  };

  const rand = (min, max) => Math.random() * (max - min) + min;

  const makeParticle = (initial = false) => {
    const size = rand(settings.minSize, settings.maxSize);
    return {
      x: rand(0, w),
      y: initial ? rand(0, h) : -size - rand(0, h * 0.15),
      r: size,
      vy: rand(settings.minSpeed, settings.maxSpeed),
      vx: rand(-settings.drift, settings.drift),
      o: rand(settings.opacityMin, settings.opacityMax)
    };
  };

  const init = () => {
    particles = Array.from({ length: settings.count }, () => makeParticle(true));
  };

  const draw = () => {
    ctx.clearRect(0, 0, w, h);
    for (const p of particles) {
      ctx.beginPath();
      ctx.fillStyle = `rgba(255,255,255,${p.o})`;
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();

      p.y += p.vy;
      p.x += p.vx;

      // wrap
      if (p.y > h + p.r) {
        Object.assign(p, makeParticle(false));
        p.y = -p.r;
      }
      if (p.x > w + p.r) p.x = -p.r;
      if (p.x < -p.r) p.x = w + p.r;
    }
    raf = requestAnimationFrame(draw);
  };

  const start = () => {
    resize();
    init();
    if (!raf) draw();
  };

  const stop = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = null;
    ctx.clearRect(0, 0, w, h);
  };

  // Public toggle (optional)
  window.PP_SNOW = { start, stop };

  window.addEventListener("resize", resize);
  start();
})();
